import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isLoading && !$setup.isDesktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "spinner" }, null, -1)
      ]))]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        ($setup.isDesktop)
          ? (_openBlock(), _createBlock($setup["BuilderEstimatorSummaryDesktop"], {
              key: 0,
              "builder-logo": $setup.props.builderLogo,
              "form-data": $setup.props.formData,
              "total-price": $props.totalPrice,
              "show-success-message": $setup.showSuccessMessage,
              onSelectPrev: $setup.onSelectPrev,
              isLoading: $setup.isLoading,
              onOnSubmit: $setup.onFormSubmit
            }, null, 8, ["builder-logo", "form-data", "total-price", "show-success-message", "isLoading"]))
          : (_openBlock(), _createBlock($setup["BuilderEstimatorSummaryMobile"], {
              key: 1,
              "builder-logo": $setup.props.builderLogo,
              "form-data": $setup.props.formData,
              "total-price": $props.totalPrice,
              "show-success-message": $setup.showSuccessMessage,
              onSelectPrev: $setup.onSelectPrev,
              onOnSubmit: $setup.onFormSubmit
            }, null, 8, ["builder-logo", "form-data", "total-price", "show-success-message"]))
      ], 64))
}